import script from "./ExpertMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertMain.vue?vue&type=script&setup=true&lang=js"

import "./ExpertMain.vue?vue&type=style&index=0&id=8840a73c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8840a73c"]])

export default __exports__